/* Graph of Life brand v1.1.0 · tokens.json */
import React, { createContext, useContext, useState, useCallback } from 'react';
import { AnimatePresence } from 'framer-motion';
import GuidedWalkthrough from '@/components/gol/GuidedWalkthrough';

// App-level provider so the cinematic pass can be launched from the hero,
// the nav or anywhere else, and stays mounted across route changes.
const WalkthroughContext = createContext({ openWalkthrough: () => {} });

export const useWalkthrough = () => useContext(WalkthroughContext);

export const WalkthroughProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openWalkthrough = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <WalkthroughContext.Provider value={{ openWalkthrough }}>
      {children}
      <AnimatePresence>
        {open && <GuidedWalkthrough open onClose={close} />}
      </AnimatePresence>
    </WalkthroughContext.Provider>
  );
};

export default WalkthroughProvider;
